import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService, DefaultLangChangeEvent } from '@ngx-translate/core';
import { MessageService as PrimeNGMsgService} from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { ActivatedRoute } from '@angular/router';

import { MessageService} from 'src/app/core/services/message.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  providers: [PrimeNGMsgService],
})
export class MessagesComponent implements OnInit, OnDestroy {

	public messageService:MessageService;

	constructor ( public msg:MessageService
		, private translateService: TranslateService
		, private primeMsgService: PrimeNGMsgService
		, private route: ActivatedRoute ) {
			this.messageService = msg;
		}

	ngOnInit(): void {
		console.logEx( "MessagesComponent.OnInit",  this.messageService );
		if( this.messageService == undefined || this.messageService.message.trim() == '')
		{
			this.messageService = new MessageService();
			this.route.queryParams.subscribe(params => {
				const msgId = params['msgid']??"ERRORS.MISSING_MSG_ID";
				this.messageService.set ( msgId )
			});
	
		}
	}

	ngOnDestroy(): void {
		this.messageService.clear();
	}
	
}
